import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCanvasGrid: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCanvasGrid"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM11.25 19.5H12.75V17.5H11.25V19.5ZM11.25 8.5V11.25H8.5V12.75H11.25V15.5H12.75V12.75H15.5V11.25H12.75V8.5H11.25ZM4.5 12.75H6.5V11.25H4.5V12.75ZM17.5 12.75H19.5V11.25H17.5V12.75ZM11.25 6.5H12.75V4.5H11.25V6.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCanvasGrid;
